(function () {
    'use strict';

    angular
        .module('app.home')
        .component('sc3RequestTransfer', {
            templateUrl: 'app/home/request-transfer/request-transfer.component.html',
            controller: RequestTransferComponent
        });

    var noop = angular.noop;

    RequestTransferComponent.$inject = ['$state', 'user', 'Member', 'Club', 'homeStateName', 'alert', 'home_resources'];
    function RequestTransferComponent($state, user, Member, Club, homeStateName, alert, resources) {
        var ctrl = this,
            current;

        // Properties
        ctrl.form = null;
        ctrl.club = null;
        ctrl.processing = false;

        // Methods
        ctrl.datasource = datasource;
        ctrl.formatter = formatter;
        ctrl.submit = submit;
        ctrl.cancel = cancel;

        /////////////////////

        function submit() {
            if (ctrl.form.$valid) {
                ctrl.processing = true;
                Member.requestTransfer({ id: user.id, clubId: ctrl.club.id }, success, error, true);
            }

            function success() {
                alert.success(resources.clubTransferSuccess).then(cancel, cancel);
            }

            function error() {
                ctrl.processing = false;
                alert.error(resources.clubTransferFailed);
            }
        }

        function cancel() {
            $state.go(homeStateName);
        }

        function datasource(text) {
            if (current)
                current.$cancelRequest();
            current = Club.search({ text: text, $top: 10 });
            return current.$promise.then(success, noop);

            function success(data) {
                return data.clubs;
            }
        }

        function formatter(club) {
            return club && club.name || '';
        }
    }
})();